import { render, staticRenderFns } from "./redactOrAdd.vue?vue&type=template&id=0148de2b&"
import script from "./redactOrAdd.vue?vue&type=script&lang=js&"
export * from "./redactOrAdd.vue?vue&type=script&lang=js&"
import style0 from "./redactOrAdd.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports